import { render, staticRenderFns } from "./ListArchive.vue?vue&type=template&id=3a29a24b"
import script from "./ListArchive.vue?vue&type=script&lang=js"
export * from "./ListArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports